<div class="preferences-container">
  <!-- Options List -->
  <div class="options-sidebar">
    <div class="sidebar-header">
      <label>{{'SIDE_NAV_PREFERENCES' | translate}}</label>
    </div>

    <mat-list class="options-list">
      @for(option of preferencesOptions; track option.id){
      <ng-container>
        @if(option.isVisible) {
        <mat-list-item (click)="selectOption(option.id)" [class.selected]="selectedOptionId === option.id"
          class="option-item">
          <div matListItemTitle>{{option.label | translate}}</div>
        </mat-list-item>
        }
      </ng-container>
      }

    </mat-list>
  </div>

  <!-- Content Area -->
  <div class="content-area">
    <div class="content-header">
      <div class="header-info">
        <label>{{getSelectedOption()?.label | translate}}</label>
      </div>
    </div>

    <mat-divider></mat-divider>

    <div class="content-body">
      @switch (selectedOptionId) {
      <!-- Collaborators Content -->
      @case (preferencesOptionId.COLLABORATORS) {
      <div class="settings-section">
        <app-sol-preferences-collaborators></app-sol-preferences-collaborators>
      </div>
      }

      <!-- Cost Reviewers Content -->
      @case (preferencesOptionId.COST_REVIEWERS) {
      <div class="settings-section">
        <app-sol-preferences-cost-reviewers></app-sol-preferences-cost-reviewers>
      </div>
      }

      <!-- Cost Review CC Content -->
      @case (preferencesOptionId.COST_REVIEW_CC) {
      <div class="settings-section">
        <app-sol-preferences-cost-review-cc></app-sol-preferences-cost-review-cc>
      </div>
      }

      <!-- Contact Info Content -->
      @case (preferencesOptionId.CONTACT_INFO) {
      <div class="settings-section">
        <app-sol-preferences-contact-info></app-sol-preferences-contact-info>
      </div>
      }

      <!-- Estimator (Si-Quote User) Content -->
      @case (preferencesOptionId.ESTIMATOR) {
      <div class="settings-section">
        <app-sol-preferences-estimator></app-sol-preferences-estimator>
      </div>
      }

      <!-- Display/Units Content -->
      @case (preferencesOptionId.DISPLAY_UNITS) {
      <div class="settings-section">
        <app-sol-preferences-display-units></app-sol-preferences-display-units>
      </div>
      }
      }
    </div>

    <!-- Sticky Footer with Save / Cancel Buttons -->
    <div class="content-footer">
      <button mat-raised-button color="primary" (click)="save()">
        {{ 'SAVE' | translate }}
      </button>
      <button class="mat-warn" mat-raised-button (click)="cancelPreferences()">
        {{ 'CANCEL' | translate }}
      </button>
    </div>
  </div>
</div>